module.exports = __webpack_public_path__ + "static/media/conferencia-pablo-jimenez.babbdbea.png";